<template>
  <div class="menuContentBox">
    <div style="width: 100%;background-color: #fff;">
  <router-view/>
  </div>
  </div>
</template>
<script>
export default {
  name: 'investor',
  props: {
  },
  data() {
    return {
      title:''
    }
  },
  mounted() {
    this.title = this.$route.query.type
  },
	methods: {
		goMore(url,key) {
      this.$router.push({
				path: url,
				query: { type: key }
			})
      this.$parent.$parent.clearHeadFun()
		},
		backhome() {
			this.$router.push('/')
		}
	}
}
</script>
<style scoped lang="less">
@import "../../css/components.less";
</style>